import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FarmaError } from 'src/integracoes/modelos/erros';
import {
  CREATE_PAINEL_INIT,
  MODIFY_PAINEL_INIT,
  LIST_PAINEL_INIT,
  DELETE_PAINEL_INIT
} from '../actionTypes';
import {
  paineisErrorMsg,
  modifyPainelSuccess,
  createPainelSuccess,
  listPainelSuccess,
  deletePainelSuccess
} from './actions';
import { atualizarPainel, criarPainel, deletarPainel, listarPaineis } from 'src/integracoes/servicos/mongo-atlas/funcoes/paineis';

interface FetchListaPainelResult {
  isError: boolean;
  allPaineis: any[] | null;
  errorMessage: string | null;
}

/* ------------------Lista paineis---------------- */
export const fetchListarPaineis = async (): Promise<FetchListaPainelResult> => {
  try {
    const { status, dados, mensagem } = await listarPaineis();

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        allPaineis: dados,
        errorMessage: null,
      };
    }

    return {
      isError: true,
      allPaineis: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarPaineis() {
  try {
    const { isError, allPaineis, errorMessage } = yield call(fetchListarPaineis);

    if (!isError) {
      yield put(listPainelSuccess({ allPaineis }));
    } else {
      yield put(paineisErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    yield put(
      paineisErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchListarPaineis() {
  yield takeEvery(LIST_PAINEL_INIT, parseListarPaineis);
}

/* ------------------Criar painel ---------------- */
export const fetchCriarPainel = async (painel: any) => {
  try {
    const { status, dados, mensagem } = await criarPainel(painel);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarPainel({ payload }: { payload: any, type: any }) {
  const { painel } = payload;
  try {
    const { isCreated, msg, data } = yield call(fetchCriarPainel, painel);
    if (isCreated) {
      yield put(createPainelSuccess({ isCreated, painel: data, msg: msg }));
    } else {
      yield put(paineisErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      paineisErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarPainel() {
  yield takeEvery(CREATE_PAINEL_INIT, parseCriarPainel);
}


/* ------------------Atualiza painel ---------------- */
export const fetchAtualizarPainel = async (id: string, painel: any) => {
  try {
    const { status, dados, mensagem } = await atualizarPainel(id, painel);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarPainel({ payload }: { payload: any; type: any }) {
  const { id, painel } = payload;

  try {
    const { isUpdated, msg } = yield call(fetchAtualizarPainel, id, painel);

    if (isUpdated) {
      yield put(modifyPainelSuccess({
        isUpdated,
        msg,
        painel: payload.painel
      }));
    } else {
      yield put(paineisErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(

      paineisErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarPainel() {
  yield takeEvery(MODIFY_PAINEL_INIT, parseAtualizarPainel);
}

/* ------------------Deletar painel ---------------- */
export const fetchDeletarPainel = async (id: string) => {
  try {
    const { status, mensagem } = await deletarPainel(id);
    if (status) {
      return { isDeleted: true, msg: mensagem };
    } else {
      return {
        isDeleted: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarPainel({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isDeleted, msg } = yield call(fetchDeletarPainel, id);

    if (isDeleted) {
      yield put(deletePainelSuccess(
        {
          isDeleted,
          msg,
          id
        }));
    } else {
      yield put(paineisErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      paineisErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarPainel() {
  yield takeEvery(DELETE_PAINEL_INIT, parseDeletarPainel);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarPaineis),
    fork(watchCriarPainel),
    fork(watchAtualizarPainel),
    fork(watchDeletarPainel),
  ]);
}
